import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { rootGuard } from './guards/root.guard';
import { gpsPermissionGuard } from './guards/gps-permission.guard';
import { activacionDeactivateGuard } from './guards/activacion-deactivate.guard';

// Eager: rutas públicas necesarias en el boot inicial
import { LoginComponent } from './pages/login/login';
import { GpsDenegadoComponent } from './pages/gps-denegado/gps-denegado';
import { MainLayoutComponent } from './components/main-layout/main-layout';

export const routes: Routes = [
  { path: '', pathMatch: 'full', canActivate: [rootGuard], component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'gps-denegado', component: GpsDenegadoComponent },

  // Rutas de password — lazy
  {
    path: 'password/expired',
    loadComponent: () => import('./pages/password/password-expired/password-expired')
      .then(m => m.PasswordExpiredComponent)
  },
  {
    path: 'password/reset-request',
    loadComponent: () => import('./pages/password/reset-password-request/reset-password-request')
      .then(m => m.ResetPasswordRequestComponent)
  },
  {
    path: 'password/reset',
    loadComponent: () => import('./pages/password/reset-password/reset-password')
      .then(m => m.ResetPasswordComponent)
  },

  // Rutas de onboarding — lazy
  {
    path: 'onboarding/verify-email',
    loadComponent: () => import('./pages/onboarding/onboarding-verify-email/onboarding-verify-email')
      .then(m => m.OnboardingVerifyEmailComponent)
  },
  {
    path: 'onboarding/verify-sms',
    loadComponent: () => import('./pages/onboarding/onboarding-verify-sms/onboarding-verify-sms')
      .then(m => m.OnboardingVerifySmsComponent)
  },
  {
    path: 'onboarding/enter-token',
    loadComponent: () => import('./pages/onboarding/onboarding-enter-token/onboarding-enter-token')
      .then(m => m.OnboardingEnterTokenComponent)
  },
  {
    path: 'onboarding/complete-profile',
    loadComponent: () => import('./pages/onboarding/onboarding-complete-profile/onboarding-complete-profile')
      .then(m => m.OnboardingCompleteProfileComponent)
  },

  // Layout principal con rutas protegidas — hijos lazy
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard-main/dashboard-main')
          .then(m => m.DashboardComponent)
      },
      {
        path: 'settings/change-password',
        loadComponent: () => import('./pages/password/change-password/change-password')
          .then(m => m.ChangePasswordComponent)
      },
      {
        path: 'venta-paquetes/inicio',
        loadComponent: () => import('./pages/ventas/venta-paquete/venta-paquete')
          .then(m => m.VentaPaqueteComponent),
        canActivate: [gpsPermissionGuard]
      },
      {
        path: 'soporte',
        loadComponent: () => import('./pages/dashboard/dashboard-soporte/dashboard-soporte')
          .then(m => m.DashboardSoporteComponent)
      },
      {
        path: 'soporte/usuarios',
        loadComponent: () => import('./pages/soporte/soporte-usuarios/soporte-usuarios')
          .then(m => m.SoporteUsuariosComponent)
      },
      {
        path: 'soporte/roles',
        loadComponent: () => import('./pages/soporte/soporte-roles/soporte-roles')
          .then(m => m.SoporteRolesComponent)
      },
      {
        path: 'soporte/roles/crear',
        loadComponent: () => import('./pages/soporte/crear-rol/crear-rol')
          .then(m => m.CrearRolComponent)
      },
      {
        path: 'soporte/grupos',
        loadComponent: () => import('./pages/soporte/soporte-grupos/soporte-grupos')
          .then(m => m.SoporteGruposComponent)
      },
      {
        path: 'soporte/grupos/crear',
        loadComponent: () => import('./pages/soporte/crear-grupo/crear-grupo')
          .then(m => m.CrearGrupoComponent)
      },
      {
        path: 'soporte/groupsmapping',
        loadComponent: () => import('./pages/soporte/soporte-mapeo-grupos/soporte-mapeo-grupos')
          .then(m => m.SoporteMapeoGruposComponent)
      },
      {
        path: 'soporte/groupsmapping/crear',
        loadComponent: () => import('./pages/soporte/crear-mapeo-grupo/crear-mapeo-grupo')
          .then(m => m.CrearMapeoGrupoComponent)
      },
      {
        path: 'numeros-pos',
        loadComponent: () => import('./pages/numeros-pos/numeros-pos')
          .then(m => m.NumerosPosComponent)
      },
      {
        path: 'numeros-pos/crear',
        loadComponent: () => import('./pages/crear-pos/crear-pos')
          .then(m => m.CrearPosComponent)
      },
      {
        path: 'pin/cambiar',
        loadComponent: () => import('./pages/pin/cambio-pin/cambio-pin')
          .then(m => m.CambioPinComponent)
      },
      {
        path: 'recargas/nueva',
        loadComponent: () => import('./pages/recargas/formulario-recarga/formulario-recarga')
          .then(m => m.FormularioRecargaComponent),
        canActivate: [gpsPermissionGuard]
      },
      {
        path: 'reportes',
        loadComponent: () => import('./pages/reportes/reportes/reportes')
          .then(m => m.ReportesComponent)
      },
      {
        path: 'perfil',
        loadComponent: () => import('./pages/perfil/perfil')
          .then(m => m.PerfilComponent)
      },
      {
        path: 'portabilidad',
        loadComponent: () => import('./pages/portabilidad/portabilidad')
          .then(m => m.PortabilidadComponent)
      },
      {
        path: 'activaciones_prepago',
        loadComponent: () => import('./pages/activaciones-prepago/activaciones-prepago')
          .then(m => m.ActivacionesPrepagoComponent),
        canActivate: [gpsPermissionGuard],
        canDeactivate: [activacionDeactivateGuard]
      },
      // [TEMPORAL] Ejecutar workflow de activaciones — eliminar tras pruebas
      {
        path: 'activaciones/execute-workflow',
        loadComponent: () => import('./pages/execute-workflow-activations/execute-workflow-activations')
          .then(m => m.ExecuteWorkflowActivationsComponent)
      },
    ]
  },
  { path: '**', redirectTo: '/login' }
];
